/**
 * Catalog-fixed equipment type numbers (frontend mirror of backend helper).
 * Default/common = 1; other categories follow catalog order.
 */

export function isDefaultCategory(cat) {
  if (!cat) return false;
  const key = String(cat.category_key || cat.key || '')
    .trim()
    .toLowerCase();
  if (key === 'common' || key === 'default' || key === 'ss_default') return true;
  return /^(default|common\s*\/\s*base|ss\s*default)$/i.test(String(cat.label || '').trim());
}

export function orderCatalogCategories(categories) {
  const list = Array.isArray(categories) ? [...categories] : [];
  list.sort((a, b) => {
    const ad = isDefaultCategory(a) ? 0 : 1;
    const bd = isDefaultCategory(b) ? 0 : 1;
    if (ad !== bd) return ad - bd;
    const ao = Number(a.sort_order);
    const bo = Number(b.sort_order);
    if (Number.isFinite(ao) && Number.isFinite(bo) && ao !== bo) return ao - bo;
    return String(a.label || '').localeCompare(String(b.label || ''));
  });
  return list;
}

export function catalogSubNumber(categoryKeyOrCat, categories) {
  const ordered = orderCatalogCategories(categories);
  if (!ordered.length) return null;
  const key =
    typeof categoryKeyOrCat === 'string'
      ? String(categoryKeyOrCat).trim().toLowerCase()
      : String(categoryKeyOrCat?.category_key || categoryKeyOrCat?.key || '')
          .trim()
          .toLowerCase();
  const label =
    typeof categoryKeyOrCat === 'object'
      ? String(categoryKeyOrCat?.label || '')
          .trim()
          .toLowerCase()
      : '';

  if (
    key === 'common' ||
    key === 'default' ||
    key === 'ss_default' ||
    /^(default|common\s*\/\s*base|ss\s*default)$/i.test(label)
  ) {
    return 1;
  }

  const idx = ordered.findIndex((c) => {
    const ck = String(c.category_key || c.key || '')
      .trim()
      .toLowerCase();
    const cl = String(c.label || '')
      .trim()
      .toLowerCase();
    return (key && ck === key) || (label && cl === label);
  });
  if (idx < 0) return null;
  return idx + 1;
}

export function maxCatalogSubNumber(categories) {
  return orderCatalogCategories(categories).length;
}

export function normalizeCategoryKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 120);
}

export function sameEquipmentType(stored, wanted) {
  const have = [stored?.category_key, stored?.label]
    .map(normalizeCategoryKey)
    .filter(Boolean);
  const want = [wanted?.key, wanted?.category_key, wanted?.label]
    .map(normalizeCategoryKey)
    .filter(Boolean);
  return want.some((key) => have.includes(key));
}
